import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { RoleplayService, StepperContent } from '../../../service/roleplay/roleplay.service';
import { Subscription } from 'rxjs';
import { ChatService } from '../../../service/chat-service';
import { BodyColorService } from '../../../service/bodyColor/bodycolor.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';
import { ToastrService } from 'ngx-toastr';


@Component({
    selector: 'app-roleplay-step5',
    templateUrl: './roleplay-step5.component.html',
    styleUrl: '../../../../assets/css/roleplay.scss',
    standalone: false
})
export class RoleplayStep5Component {
  step5Form: FormGroup;
  sharedData: any = {};
  subscription: Subscription;
  profileSubscription: any = new Subscription();
  color: string = '#e8e6e3';
  inputValue: string;
  isPopupVisible: boolean = false;
  isScenarioVisible: boolean = true;
  isNextVisible: boolean = false;
  data: any = [];
  isEditMode: boolean = false;
  getData: any = {};
  createUpdateText: string = "created";
  ScenarioS: boolean = false;
  scenario_name: string = "";

  constructor(public Router: Router, private fb: FormBuilder, private sharedService: RoleplayService,
    public ChatService: ChatService, private toastrService: ToastrService, private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.sharedService.editMode$.subscribe(mode => {
      this.isEditMode = mode;
      if (this.isEditMode) {
        this.ScenarioS = true;
      }
    });

    const outerDiv = document.getElementById('outerContainer');
    outerDiv.style.display = 'none';

    this.step5Form = this.fb.group({
      customerName: ['', Validators.required],
      guidelineRule: this.fb.array([]),
      guidelineInputs: this.fb.array([])
    });
    if (this.isEditMode) {
      this.sharedService.data$.subscribe({
        next: data => {
          this.data = data;
          const updatedMetaData = this.data[0].meta_data.filter(item => item.roleplay_metadata_type === 'guideline_rule').map(items => {
            const { roleplay_metadata_val: name, id } = items;
            return { name, id }
          });
          this.scenario_name = this.data[0].scenario_name;
          const PreviousData = this.ifPreviousSelectedData();

          if (this.sharedService.rolePlayScenarioData.step5) {
            this.setGuidelineRuleData(PreviousData);
          } else {
            this.setGuidelineRuleData(updatedMetaData);
          }
          this.step5Form.patchValue({
            customerName: this.data[0].scenario_name
          });
        },
        error: error => console.error('Error receiving data', error),
        complete: () => console.log('Data stream completed')
      });

    } else {
      this.subscription = this.sharedService.data$$.subscribe(response => {
        const PreviousData = this.ifPreviousSelectedData();

        if (this.sharedService.rolePlayScenarioData.step5) {
          this.setGuidelineRuleData(PreviousData);
        } else {
          this.setGuidelineRuleData(response['guideline_rule']);
        }
      }
      );
    }
  }

  ifPreviousSelectedData() {
    if (this.sharedService.rolePlayScenarioData.roleplay_metadata.length) {
      const metaDataArray = this.sharedService.rolePlayScenarioData.roleplay_metadata;
      const objectiveMetaDataArray: any = metaDataArray.filter(data => {
        return data.type_name === "guideline_rule";
      });
      const updatedData = objectiveMetaDataArray.map(item => {
        const { type_value } = item;
        return { name: type_value };
      });

      return updatedData;
    }
    return [];
  }

  ScenarioName(event) {
    if (event.target.value != '') {
      this.ScenarioS = true;
    } else {
      this.ScenarioS = false;
    }
  }
  groupByMetadataType() {
    return this.data[0].meta_data.reduce((acc, item) => {
      const { roleplay_metadata_type } = item;
      if (!acc[roleplay_metadata_type]) {
        acc[roleplay_metadata_type] = [];
      }
      const { id, roleplay_metadata_val: name } = item;
      acc[roleplay_metadata_type].push({ id, name });
      return acc;
    }, {});
  }


  get guidelineInputs() {
    return this.step5Form.get('guidelineInputs') as FormArray;
  }
  get guidelineRule(): FormArray {
    return this.step5Form.get('guidelineRule') as FormArray;
  }
  addInput() {
    this.guidelineRule.push(this.fb.control(''));
  }
  removeInput(index: number): void {
    this.guidelineRule.removeAt(index);
  }

  setGuidelineRuleData(guidelineRule: any[]): void {
    const guidelineRuleFGs = guidelineRule.map(objective => this.fb.control(objective.name, Validators.required));
    const guidelineRuleFormArray = this.fb.array(guidelineRuleFGs);
    this.step5Form.setControl('guidelineRule', guidelineRuleFormArray);
  }

  updateSelected(optionIndex: number, optionId: string, event: Event, type: string) {
    this.updateSelectedSection(optionIndex, optionId, event, this.guidelineRule, 'guidelineRule');

  }
  updateSelectedSection(optionIndex: number, optionId: string, event: Event, sectionArray: any, formControlName: string) {
    sectionArray.forEach((x, i) => {
      if (i == optionIndex) {
        if (x['checked']) {
          delete x['checked']
        } else {
          x['checked'] = true;
        }
      }
    })
  }

  goBack() {
    this.sharedService.rolePlayScenarioData.roleplay_metadata =
      this.sharedService.rolePlayScenarioData.roleplay_metadata.filter(item =>
        item.type_name !== 'guideline_rule');
    let guiRule = this.step5Form.value.guidelineRule;
    if (guiRule.length > 0) {
      guiRule = guiRule.filter(item => item?.trim());
      guiRule.forEach(data => {
        this.sharedService.rolePlayScenarioData.roleplay_metadata.push(
          {
            type_name: "guideline_rule",
            type_value: data
          }
        )
      })
    }
    this.sharedService.rolePlayScenarioData.step5 = true;
    this.Router.navigate(['/app-roleplay-step4', { mode: 'roleplay' }], { skipLocationChange: true });
    this.sharedService.changeStepper({ current: 4, type: 'N' });
  }

  enterScenario() {
    this.Router.navigate(['/app-roleplay-step6'], { skipLocationChange: true });
    this.sharedService.changeStepper({ current: 6, type: 'N' });
  }
  summary() {
    this.Router.navigate(['/app-roleplay-step6'], { skipLocationChange: true });
    this.sharedService.changeStepper({ current: 6, type: 'N' });
  }
  goBackScenario() {
    const inner = document.getElementById('innercontainer');
    inner.style.display = 'block';
    const outer = document.getElementById('outerContainer');
    outer.style.display = 'none';
    outer.style.padding = '15px';
    this.isScenarioVisible = true;
    this.isNextVisible = false;
  }

  closePopup() {
    this.isPopupVisible = false;
    this.Router.navigate(['/app-trainee-dasboard', { mode: 'roleplay' }], { skipLocationChange: true });
    this.sharedService.changeStepper({ current: 4, type: 'N' });
  }

  showDialog(createUpdateText) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      width: '350px',
      data: { title:'Confirmation', message: `You have successfully ${createUpdateText} roleplay scenario!`, okOnly: true }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        return;
      } else {
        this.closePopup();
      }
    });
  }

  next() {
    this.inputValue = this.step5Form.value.customerName;
    if (!this.inputValue) {
      console.log('Input is required');
      // You can add more logic here to handle the validation
    } else {
      this.sharedService.rolePlayScenarioData.roleplay_metadata =
        this.sharedService.rolePlayScenarioData.roleplay_metadata.filter(item =>
          item.type_name !== 'guideline_rule');
      this.step5Form.value.guidelineRule.forEach(data => {
        this.sharedService.rolePlayScenarioData.roleplay_metadata.push(
          {
            type_name: "guideline_rule",
            type_value: data
          }
        )
      })
      this.sharedService.rolePlayScenarioData.scenario_name = this.inputValue;

      if (this.isEditMode) {
        const createRoleplayRequest = this.sharedService.rolePlayScenarioData;
        this.sharedService.updateRolePlayScenario(this.data[0].scenario_id, createRoleplayRequest).subscribe((data: any[]) => {
          // this.isPopupVisible = true;
          this.showDialog('updated');
        });
      } else {
        const createRoleplayRequest = this.sharedService.rolePlayScenarioData;
        this.sharedService.createRolePlayScenario(createRoleplayRequest).subscribe((data: any[]) => {
          // this.isPopupVisible = true;
          this.showDialog('created');
        });
      }
    }
  }

  goToStep(id: number) {
    const stepper_data: StepperContent = this.sharedService.stepperContent.find(stepper => stepper.stepId == id);
    this.changeStepper(stepper_data);
  }

  changeStepper(stepper_data: StepperContent) {
    console.log('Step5 : changeStepper: ', stepper_data);
    const current_step_id = 5;
    if (this.step5Form.valid) {
      this.sharedService.changeStep(stepper_data);
    } else {
      this.toastrService.error('Invalid Form')
    }
  }
  goBackMain() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: { message: 'You will lose all changes. Do you really want to leave?' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }
      this.Router.navigate(['/app-trainee-dasboard'], { skipLocationChange: true });
    });
  }
}
